if(!window.__bcLpInit){window.__bcLpInit=1;


(function(){var t=11*3600+58*60+10,el=document.getElementById('annTimer');if(!el)return;setInterval(function(){t=t>0?t-1:12*3600;
el.querySelector('[data-u=h]').textContent=String(Math.floor(t/3600)).padStart(2,'0');
el.querySelector('[data-u=m]').textContent=String(Math.floor(t%3600/60)).padStart(2,'0');
el.querySelector('[data-u=s]').textContent=String(t%60).padStart(2,'0');},1000);})();
(function(){var t=300,el=document.getElementById('urgTimer');if(!el)return;/*flipNotch*/el.querySelectorAll('b').forEach(function(bb){var n=document.createElement('i');bb.appendChild(n);});setInterval(function(){t=t>0?t-1:300;
el.querySelector('[data-u=m]').textContent=String(Math.floor(t/60)).padStart(2,'0');
el.querySelector('[data-u=s]').textContent=String(t%60).padStart(2,'0');},1000);})();
(function(){var imgs=window.BC_GALLERY||[];var tb=document.getElementById('thumbs');if(!tb)return;
var track=document.getElementById('galTrack'),main=document.getElementById('galMain');
function setOn(i){tb.querySelectorAll('img').forEach(function(x,k){x.classList.toggle('on',k===i);});
  var th=tb.querySelectorAll('img')[i];if(th&&th.scrollIntoView)th.scrollIntoView({block:'nearest',inline:'nearest'});
  var pr=document.getElementById('galProg');
  if(pr&&imgs.length){pr.style.width=(100/imgs.length)+'%';pr.style.transform='translateX('+(i*100)+'%)';}}
setOn(0);
var thumbsSrc=window.BC_THUMBS||imgs;
imgs.forEach(function(src,i){var im=new Image();im.src=thumbsSrc[i]||src;im.loading='lazy';im.decoding='async';if(i===0)im.className='on';
im.onclick=function(){if(track){track.scrollTo({left:i*track.clientWidth,behavior:'smooth'});}else if(main){main.src=src;}setOn(i);};tb.appendChild(im);});
if(track){
  track.scrollLeft=0;
  window.addEventListener('pageshow',function(ev){if(ev.persisted){track.scrollLeft=0;setOn(0);}});
  var t;track.addEventListener('scroll',function(){clearTimeout(t);t=setTimeout(function(){
    setOn(Math.round(track.scrollLeft/track.clientWidth));},80);},{passive:true});
  var down=false,sx=0,sl=0,moved=false;
  track.addEventListener('mousedown',function(e){down=true;moved=false;sx=e.pageX;sl=track.scrollLeft;track.classList.add('dragging');e.preventDefault();});
  window.addEventListener('mousemove',function(e){if(!down)return;var dx=e.pageX-sx;if(Math.abs(dx)>4)moved=true;track.scrollLeft=sl-dx;});
  window.addEventListener('mouseup',function(){if(!down)return;down=false;track.classList.remove('dragging');
    var i=Math.max(0,Math.min(imgs.length-1,Math.round(track.scrollLeft/track.clientWidth)));
    track.scrollTo({left:i*track.clientWidth,behavior:'smooth'});setOn(i);});
  track.addEventListener('click',function(e){if(moved){e.preventDefault();e.stopPropagation();}},true);
}})();
(function(){
var TALLAS=window.BC_SIZES||['XS','S','M','L','XL','2XL','3XL'],COLORES=window.BC_COLORS||['Negro','Beige','Azul Marino','Morado','Rosa Fucsia','Morado Oscuro','Lila'];
var hasColor=COLORES.length>0;
document.querySelectorAll('.bc-lp .bundle').forEach(function(b){
  var n=+b.dataset.pieces,box=b.querySelector('.bsels');
  if(!hasColor)box.classList.add('no-color');
  var head=document.createElement('div');head.className='selhead';head.innerHTML='<span></span><span>'+(window.BC_LBL_SIZE||'Talla')+'</span>'+(hasColor?('<span>'+(window.BC_LBL_COLOR||'Color')+'</span>'):'');box.appendChild(head);
  var swatch=function(c){var idx=(window.BC_CIMG||{})[c];var th=window.BC_THUMBS||[];
    if(idx!=null&&th[idx])return '<img src="'+th[idx]+'" alt="">';
    var hx=(window.BC_CHEX||{})[c];
    return hx?('<span class="cdd-noimg" style="background:'+hx+';border:1px solid rgba(0,0,0,.18)"></span>'):'<span class="cdd-noimg"></span>';};
  var mk=function(i,defIdx){defIdx=defIdx||0;var defC=COLORES[defIdx]||COLORES[0];var row=document.createElement('div');row.className='selrow';
    var cddList=hasColor?COLORES.map(function(c){return '<div class="cdd-item" data-v="'+c.replace(/"/g,'&quot;')+'">'+swatch(c)+'<span>'+c+'</span></div>';}).join(''):'';
    row.innerHTML='<span class="n">'+(i?('#'+i):'')+'</span><select class="s-t">'+TALLAS.map(t=>'<option>'+t+'</option>').join('')+'</select>'
      +(hasColor?('<span class="cdd"><select class="s-c" style="display:none">'+COLORES.map(c=>'<option'+(c===defC?' selected':'')+'>'+c+'</option>').join('')+'</select>'
      +'<button type="button" class="cdd-btn">'+swatch(defC)+'<span class="cdd-lbl">'+defC+'</span><i>▾</i></button>'
      +'<div class="cdd-list" style="display:none">'+cddList+'</div></span>'):'');
    box.appendChild(row);};
  if(n>1){for(var i=1;i<=n;i++)mk(i,(n===2&&COLORES.length===2)?(i-1):0);}else mk(0);
  b.querySelector('.bhead').addEventListener('click',function(){
    document.querySelectorAll('.bc-lp .bundle').forEach(x=>x.classList.remove('on'));b.classList.add('on');
    document.getElementById('ctaPrice').textContent='$'+b.dataset.price;
    var sp=document.getElementById('stickyPrice');if(sp)sp.textContent='$'+b.dataset.price;});
});
document.addEventListener('click',function(e){
  var btn=e.target.closest('.cdd-btn');
  if(btn){e.preventDefault();
    document.querySelectorAll('.cdd-list').forEach(function(l){if(l!==btn.parentElement.querySelector('.cdd-list'))l.style.display='none';});
    var list=btn.parentElement.querySelector('.cdd-list');
    list.style.display=(list.style.display==='none')?'block':'none';return;}
  var item=e.target.closest('.cdd-item');
  if(item){var cdd=item.closest('.cdd');var val=item.dataset.v;
    var sel=cdd.querySelector('.s-c');sel.value=val;
    var b2=cdd.querySelector('.cdd-btn');
    b2.innerHTML=item.innerHTML+'<i>▾</i>';
    b2.querySelector('span').className='cdd-lbl';
    cdd.querySelector('.cdd-list').style.display='none';
    sel.dispatchEvent(new Event('change',{bubbles:true}));return;}
  document.querySelectorAll('.cdd-list').forEach(function(l){l.style.display='none';});
});
function addToCart(items){fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
  .then(r=>{if(r.ok){ if(window.BCCart){window.BCCart.open();} else {window.location='/cart';} }else{r.json().then(j=>alert(j.description||'Error'));}});}
var CTA=document.getElementById('ctaBtn');
if(CTA)CTA.addEventListener('click',function(){
  var b=document.querySelector('.bc-lp .bundle.on');if(!b)return;
  var n=+b.dataset.pieces,rows=[].slice.call(b.querySelectorAll('.selrow'));
  if(n===1){
    if(window.BC_SET1){addToCart([{id:window.BC_SET1,quantity:1}]);return;}
    var t=rows[0].querySelector('.s-t').value,cEl=rows[0].querySelector('.s-c'),c=cEl?cEl.value:'';
    var key=window.BC_INV?(c+'|'+t):(t+'|'+c);var vid=window.BC_VMAP[key];if(!vid){alert('Variante no disponible');return;}
    addToCart([{id:vid,quantity:1}]);
  }else{var props={};rows.forEach(function(r,i){var cEl=r.querySelector('.s-c');props[(window.BC_PIECE_LABEL||'Pieza')+' '+(i+1)]=r.querySelector('.s-t').value+(cEl?(' / '+cEl.value):'');});
    var vid=(n===3||n===4)?window.BC_SET21:window.BC_SET32;
    addToCart([{id:vid,quantity:1,properties:props}]);}
});})();
(function(){
  document.addEventListener('change',function(e){
    var s=e.target.closest('.bc-lp .s-c'); if(!s)return;
    var idx=window.BC_CIMG?window.BC_CIMG[s.value]:null;
    if(idx==null)return;
    var track=document.getElementById('galTrack');
    if(track){track.scrollTo({left:idx*track.clientWidth,behavior:'smooth'});}
  });
})();
window.tScroll=function(dir){var c=document.getElementById('tcar');c.scrollBy({left:dir*c.clientWidth*0.9,behavior:'smooth'})};
(function(){var car=document.getElementById('tcar'),dwrap=document.getElementById('tdots');if(!car)return;
var N=car.children.length;for(var i=0;i<N;i++){var d=document.createElement('i');if(i===0)d.className='on';dwrap.appendChild(d);}
var dots=dwrap.querySelectorAll('i');
car.addEventListener('scroll',function(){var i=Math.round(car.scrollLeft/(car.scrollWidth/N));i=Math.max(0,Math.min(N-1,i));
dots.forEach((d,j)=>d.classList.toggle('on',j===i));},{passive:true});})();
(function(){var s=document.getElementById('stickyCta'),p=document.getElementById('comprar');if(!s||!p)return;
window.addEventListener('scroll',function(){var r=p.getBoundingClientRect();
s.classList.toggle('show',r.bottom<0||r.top>innerHeight*1.2&&scrollY>600);},{passive:true});})();


/* init precio CTA desde bundle activo */
(function(){var b=document.querySelector('.bc-lp .bundle.on');if(!b)return;
var cp=document.getElementById('ctaPrice');if(cp)cp.textContent='$'+b.dataset.price;
var sp=document.getElementById('stickyPrice');if(sp)sp.textContent='$'+b.dataset.price;})();

}
